import axios from 'axios';

export const getLocation = async (ip) => {
    try {
        const response = await axios.get(process.env.REACT_APP_GEO_IP_URL + "/api/location/" + (ip ? ip : "get"));
        if (response.data.statusCode === "1")
            return response.data;
        else
            throw new Error(response.data.statusMessage);

    } catch (error) {
        return { isError: true, message: error.message };
    }
}